module.exports = __webpack_public_path__ + "23810b0aa9ee0ea59592d98d4a66fe29.pdf";